/**
 * Provides methods to save and restore form data.
 */
import {checkedValues, checkValues} from "../extensions/Array";

export class FormStorage
{
	/**
	 * Saves a value for a key.
	 * @param {string} key
	 * @param value
	 * @param {boolean} [json]
	 */
	static set(key, value, json)
	{
		try
		{
			if (value === null)
				localStorage.removeItem(key);
			else
				localStorage.setItem(key, !json ? value : JSON.stringify(value));
		}
		catch(exception)
		{
			console.log(exception);
		}
	}

	/**
	 * Retrieves a value for a key.
	 * @param key
	 * @param {boolean} [json]
	 */
	static get(key, json)
	{
		try
		{
			let value = localStorage.getItem(key);
			return value !== null ?
				(!json ? value : JSON.parse(value)) : null;
		}
		catch(exception)
		{
			console.log(exception);
			return null;
		}
	}

	/**
	 * Gets the storage key.
	 * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} field
	 * @returns {string}
	 */
	static keyFor(field)
	{
		return (field.form ? field.form.name : 'form') + ':' + field.name;
	}

	/**
	 * Stores the value for a field.
	 * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} field
	 */
	static store(field)
	{
		try
		{
			let name = FormStorage.keyFor(field);
			let list = field.form[field.name];
			let isList = list instanceof RadioNodeList;

			switch(field.tagName)
			{
				case 'INPUT':
					switch(field.type)
					{
						case 'button':
						case 'submit':
						case 'reset':
						case 'file':
							break;

						case 'radio':
						case 'checkbox':
							let value = isList ? checkedValues(list) : field.checked;
							FormStorage.set(name, value, true);
							break;

						default:
							FormStorage.set(name, field.value);
							break;
					}
					break;

				case 'SELECT':
				case 'TEXTAREA':
					FormStorage.set(name, field.value);
					break;
			}

		}
		catch(exception)
		{
			console.log(exception);
		}
	}

	/**
	 * Restores a value for a field.
	 * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} field
	 */
	static restore(field)
	{
		try
		{
			if (field instanceof RadioNodeList)
				field = field[0];

			let name = FormStorage.keyFor(field);
			let value = FormStorage.get(name);
			if (value === null)
				return;

			let list = field.form[field.name];
			let isList = list instanceof RadioNodeList;

			switch(field.tagName)
			{
				case 'INPUT':
					switch(field.type)
					{
						case 'button':
						case 'submit':
						case 'reset':
						case 'file':
							return;

						case 'radio':
						case 'checkbox':
							value = JSON.parse(value);
							if (!isList)
							{
								field.checked = value;
								$(field).trigger('change')
							}
							else
								checkValues(list, value);
							break;

						default:
							field.value = value;
							$(field).trigger('change')
							break;
					}
					break;

				case 'SELECT':
				case 'TEXTAREA':
					field.value = value;
					$(field).trigger('change');
					break;
			}

		}
		catch(exception)
		{
			console.log(exception);
		}
	}

	/**
	 * Adds the change event listener to save the value.
	 * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement|RadioNodeList|Node} field
	 */
	static storeFieldOnChanges(field)
	{
		let listener = (function(field)
		{
			return function()
			{
				FormStorage.store(field);
			};
		})(field);

		if (field instanceof RadioNodeList)
		{
			for(let i = 0; i < field.length; i++)
				FormStorage.storeFieldOnChanges(field[i]);
		}
		else
		{
			field.addEventListener('change', listener);
		}
	}
}

window.App = window.App || {};
window.App.FormStorage = FormStorage;
